const StudentsTypes = {
  SET_STUDENTS_LOADING: 'STUDENTS/SET_STUDENTS_LOADING',
  SET_STUDENTS_FAILURE: 'STUDENTS/SET_STUDENTS_FAILURE',
  SET_STUDENTS_SUCCESS: 'STUDENTS/SET_STUDENTS_SUCCESS',
};

export default StudentsTypes;